<div class="spinner-hover" [ngStyle]="{'min-height.px': minHeight()}">
    <mat-spinner diameter="{{diameter()}}"></mat-spinner>
</div>
